import { render } from "./PharmaceuticalFormTab.vue?vue&type=template&id=d4bd797a"
import script from "./PharmaceuticalFormTab.vue?vue&type=script&lang=js"
export * from "./PharmaceuticalFormTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__